import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE,
  PaymentMethodPickerBlockDataSource,
} from './payment-method-picker-block-view-model';
import { PaymentMethodPickerBlockPreviewDataSource } from './payment-method-picker-block-preview-data-source';
import { PaymentMethodPickerBlockStoreDataSource } from './payment-method-picker-block-store-data-source';

export function providePaymentMethodPickerBlockDataSource(): Provider[] {
  return [
    PaymentMethodPickerBlockStoreDataSource,
    PaymentMethodPickerBlockPreviewDataSource,
    {
      provide: PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE,
      useFactory: (): PaymentMethodPickerBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(PaymentMethodPickerBlockPreviewDataSource)
          : inject(PaymentMethodPickerBlockStoreDataSource);
      },
    },
  ];
}
